import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { mergeMap, Observable } from 'rxjs';
import { ReCaptchaService, SKIP_RECAPTCHA_INTERCEPTOR, X_CAPTCHA_TOKEN } from '@core/recaptcha/data-access';
import { GENERIC_API_SERVICE, GENERIC_API_SOURCE } from '../constant/generic-api.constant';
import { AppConfigService } from '@core/app-config/data-access';

@Injectable()
export class ReCaptchaInterceptor implements HttpInterceptor {
  private readonly recaptchaService = inject(ReCaptchaService);
  private readonly excludeCharacters = new RegExp('[^a-zA-Z_]', 'g');
  private readonly appConfigService = inject(AppConfigService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (
      (req.method !== 'POST' && req.method !== 'PATCH') ||
      req.headers.get(GENERIC_API_SOURCE) !== GENERIC_API_SERVICE ||
      req.headers.get(SKIP_RECAPTCHA_INTERCEPTOR) === 'true'
    ) {
      return next.handle(req);
    }

    const action = this.extractActionFromRequest(req);

    console.log({ req, action });

    return this.recaptchaService.executeAsObservable(action).pipe(
      mergeMap(token => {
        req = req.clone({ headers: req.headers.set(X_CAPTCHA_TOKEN, token) });
        return next.handle(req);
      })
    );
  }

  private extractActionFromRequest(req: HttpRequest<unknown>): string {
    const config = this.appConfigService.getConfig();

    // Split the URL at the API host and prefix
    const urlParts = req.url.split(config.apiHost + config.urlPrefix);

    // If the URL contains the API host and prefix,
    // the second part will be the relevant segment
    const relevantPart = urlParts.length > 1 ? urlParts[1] : urlParts[0];

    // Replace "/" with "__" and special characters with "_"
    return relevantPart.replace(/\//g, '__').replace(this.excludeCharacters, '_').toLowerCase();
  }
}
